<template>
  <section class="body--main">
    <div class="container-fluid">
      <div class="container">
        <nav aria-label="breadcrumb" class="hide__on_mobile">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">Accueil</li>
            <li class="breadcrumb-item">NSIA Voyage</li>
            <li class="breadcrumb-item active" aria-current="page">
              Souscrire à Assurance Voyage
            </li>
          </ol>
        </nav>
        <div class="page__header--info">
          <div class="page__header--info__text">
            Souscrire à Assurance Voyage
          </div>
        </div>

        <div class="body__form--subscription">
          <div class="subscription__section">
            <div class="hide__subscription-section">
              <div class="card">
                <div class="card-body">
                  <div class="step__voyage">
                    <div class="step__voyage--item">
                      <div
                        class="custom__badge_default"
                        :class="step === 1 ? 'custom__badge--active' : ''"
                      >
                        1
                      </div>
                      <div
                        class="badge__text"
                        :class="step === 1 ? 'badge__text--active--active' : ''"
                      >
                        Informations
                      </div>
                    </div>
                    <hr />
                    <div class="step__voyage--item">
                      <div
                        class="custom__badge_default"
                        :class="step === 2 ? 'custom__badge--active' : ''"
                      >
                        2
                      </div>
                      <div
                        class="badge__text"
                        :class="step === 2 ? 'badge__text--active--active' : ''"
                      >
                        Fichiers joints
                      </div>
                    </div>
                    <hr />
                    <div class="step__voyage--item">
                      <div
                        class="custom__badge_default"
                        :class="step === 3 ? 'custom__badge--active' : ''"
                      >
                        2
                      </div>
                      <div
                        class="badge__text"
                        :class="step === 3 ? 'badge__text--active--active' : ''"
                      >
                        Résultat
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="card">
                <div class="card-body">
                  <div class="custom__badge-section d-md-none">
                    <div
                      class="custom__badge_default"
                      :class="step === 1 ? 'custom__badge--active' : ''"
                    >
                      1
                    </div>
                    <div
                      class="custom__badge_default"
                      :class="step === 2 ? 'custom__badge--active' : ''"
                    >
                      2
                    </div>
                    <div
                      class="custom__badge_default"
                      :class="step === 3 ? 'custom__badge--active' : ''"
                    >
                      3
                    </div>
                  </div>
                  <h4 class="mb-4">{{ titleStep() }}</h4>
                  <div v-if="step === 1">
                    <div class="form-row">
                      <div class="col-md-6 col-12">
                        <div class="form-check">
                          <label class="form-check-label">
                            <input
                              checked
                              @click="single()"
                              type="radio"
                              class="form-check-input"
                              name="optradio"
                            />Souscription individuelle
                          </label>
                        </div>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="form-check">
                          <label class="form-check-label">
                            <input
                              @click="group()"
                              type="radio"
                              class="form-check-input"
                              name="optradio"
                            />Souscription de groupe
                          </label>
                        </div>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="form-group">
                          <label class="form__label">Nom</label>
                          <input
                            v-model="form.data.last_name"
                            type="text"
                            class="form-control"
                          />
                          <div v-if="errors.last_name" style="color: red">
                            {{ errors.last_name[0] }}
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="form-group">
                          <label class="form__label">Prénom</label>
                          <input
                            v-model="form.data.first_name"
                            type="text"
                            class="form-control"
                          />
                          <div v-if="errors.first_name" style="color: red">
                            {{ errors.first_name[0] }}
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="form-group">
                          <label class="form__label">N° de passeport</label>
                          <input
                            v-model="form.data.passport_number"
                            type="text"
                            class="form-control"
                          />
                          <div v-if="errors.passport_number" style="color: red">
                            {{ errors.passport_number[0] }}
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="form-group">
                          <label class="form__label">Tranche d'âges</label>
                          <select
                            @change="getZone()"
                            v-model="form.data.birthday"
                            class="form-control"
                          >
                            <option value="">Selectionner</option>
                            <option
                              v-for="(item, key) in ages_section"
                              :key="key"
                              :value="item.id"
                            >
                              {{ item.name }}
                            </option>
                          </select>
                          <div v-if="errors.birthday" style="color: red">
                            {{ errors.birthday[0] }}
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="form-group">
                          <label class="form__label">Zone de destination</label>
                          <select
                            v-model="form.data.destination_area"
                            @change="getDurations()"
                            class="form-control"
                          >
                            <option value="">Selectionner</option>
                            <option
                              v-for="(item, key) in zone_section"
                              :key="key"
                              :value="item.id"
                            >
                              {{ item.zone }}
                            </option>
                          </select>
                          <div
                            v-if="errors.destination_area"
                            style="color: red"
                          >
                            {{ errors.destination_area[0] }}
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="form-group">
                          <label class="form__label"
                            >Durée du voyage (jours)</label
                          >
                          <select
                            v-model="form.data.travel_time"
                            class="form-control"
                          >
                            <option value="">Selectionner</option>
                            <option
                              v-for="(item, key) in durations"
                              :key="key"
                              :value="item.slug"
                            >
                              {{ item.duration }}
                            </option>
                          </select>
                          <div v-if="errors.travel_time" style="color: red">
                            {{ errors.travel_time[0] }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="form.data.other_people.length > 0">
                      <div
                        v-for="(item, key) in form.data.other_people"
                        :key="key"
                        class="form-row"
                      >
                        <div class="col-12">
                          <svg
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M19.5 6.48251L18.09 5.07251L12.5 10.6625L6.91 5.07251L5.5 6.48251L11.09 12.0725L5.5 17.6625L6.91 19.0725L12.5 13.4825L18.09 19.0725L19.5 17.6625L13.91 12.0725L19.5 6.48251Z"
                              fill="#E73D3E"
                            />
                          </svg>
                          <span @click="removeUser(item)" class="delete__user"
                            >Supprimer cet assuré</span
                          >
                        </div>
                        <div class="col-md-6 col-12">
                          <div class="form-group">
                            <label class="form__label">Nom</label>
                            <input
                              v-model="item.last_name"
                              type="text"
                              class="form-control"
                            />
                            <div
                              v-if="
                                errors['other_people.' + key + '.last_name']
                              "
                              style="color: red"
                            >
                              {{
                                errors["other_people." + key + ".last_name"][0]
                              }}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 col-12">
                          <div class="form-group">
                            <label class="form__label">Prénom</label>
                            <input
                              v-model="item.first_name"
                              type="text"
                              class="form-control"
                            />
                            <div
                              v-if="
                                errors['other_people.' + key + '.first_name']
                              "
                              style="color: red"
                            >
                              {{
                                errors["other_people." + key + ".first_name"][0]
                              }}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 col-12">
                          <div class="form-group">
                            <label class="form__label">N° de passeport</label>
                            <input
                              v-model="item.passport_number"
                              type="text"
                              class="form-control"
                            />
                            <div
                              v-if="
                                errors[
                                  'other_people.' + key + '.passport_number'
                                ]
                              "
                              style="color: red"
                            >
                              {{
                                errors[
                                  "other_people." + key + ".passport_number"
                                ][0]
                              }}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 col-12">
                          <div class="form-group">
                            <label class="form__label">Tranche d'âges</label>
                            <select
                              @change="getZoneChild(item)"
                              v-model="item.birthday"
                              class="form-control"
                            >
                              <option value="">Selectionner</option>
                              <option
                                v-for="(item, key) in ages_section"
                                :key="key"
                                :value="item.id"
                              >
                                {{ item.name }}
                              </option>
                            </select>
                            <div
                              v-if="errors['other_people.' + key + '.birthday']"
                              style="color: red"
                            >
                              {{
                                errors["other_people." + key + ".birthday"][0]
                              }}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 col-12">
                          <div class="form-group">
                            <label class="form__label"
                              >Zone de destination</label
                            >
                            <select
                              @change="getDurationsChild(item)"
                              v-model="item.destination_area"
                              class="form-control"
                            >
                              <option value="">Selectionner</option>
                              <option
                                v-for="(zone, key) in item.zone_section"
                                :key="key"
                                :value="zone.id"
                              >
                                {{ zone.zone }}
                              </option>
                            </select>
                            <div
                              v-if="
                                errors[
                                  'other_people.' + key + '.destination_area'
                                ]
                              "
                              style="color: red"
                            >
                              {{
                                errors[
                                  "other_people." + key + ".destination_area"
                                ][0]
                              }}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 col-12">
                          <div class="form-group">
                            <label class="form__label"
                              >Durée du voyage (jours)</label
                            >
                            <select
                              v-model="item.travel_time"
                              class="form-control"
                            >
                              <option value="">Selectionner</option>
                              <option
                                v-for="(duration, key) in item.durations"
                                :key="key"
                                :value="duration.slug"
                              >
                                {{ duration.duration }}
                              </option>
                            </select>
                            <div
                              v-if="errors['other_people.' + key + '.duration']"
                              style="color: red"
                            >
                              {{
                                errors["other_people." + key + ".duration"][0]
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="element === 1">
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.5 8.07251H8.5V14.0725H6.5V8.07251H0.5V6.07251H6.5V0.0725098H8.5V6.07251H14.5V8.07251Z"
                          fill="#002A85"
                        />
                      </svg>
                      <span @click="addUser()" class="user__add"
                        >Ajouter un assuré</span
                      >
                    </div>
                  </div>
                  <div v-show="step === 2">
                    <p>
                      Veuillez charger le(s) fichier(s) requis :
                      <span style="color: #d09a12">copie du passeport.</span>
                    </p>
                    <file-upload
                      ref="upload"
                      :acceptFile="'.jpg,.png,.gif,.jpeg,.pdf,.doc,.docx,.xls,.xlsx'"
                    />
                  </div>
                  <div v-if="step === 3">
                    <div class="detail__sup">
                      <div class="section__information">
                        <div class="section__information-text">Prime nette</div>
                        <div class="section__information-dote"></div>
                        <div class="section__information-price">
                          {{ summary.net ? $format(summary.net) : 0 + " Fcfa" }}
                        </div>
                      </div>
                      <div class="section__information">
                        <div class="section__information-text">Accessoires</div>
                        <div class="section__information-dote"></div>
                        <div class="section__information-price">
                          {{
                            summary.piece ? $format(summary.piece) : 0 + " Fcfa"
                          }}
                        </div>
                      </div>
                      <div class="section__information">
                        <div class="section__information-text">Tâxes</div>
                        <div class="section__information-dote"></div>
                        <div class="section__information-price">
                          {{
                            summary.taxe ? $format(summary.taxe) : 0 + " Fcfa"
                          }}
                        </div>
                      </div>
                      <div class="section__amount">
                        <div class="section__amount-text">Total</div>
                        <div class="section__amount-price">
                          {{ summary.total ? summary.total : 0 + " Fcfa" }}
                        </div>
                      </div>
                      <!--
                                            <div class="total__info">
                                                <div class="total__info--text">Prime net</div>
                                                <div class="total__info--price divider divider-dashed divider-right">
                                                    <div class="divider-text">106 784 Fcfa</div>
                                                </div>
                                            </div>
                                            <div class="total__info">
                                                <div class="total__info--text">Accessoires</div>
                                                <div class="total__info--price divider divider-dashed divider-right">
                                                    <div class="divider-text">106 784 Fcfa</div>
                                                </div>
                                            </div>
                                            -->
                    </div>
                    <div class="section__neg" @click="saveNegotiated()">
                      <svg
                        width="19"
                        height="20"
                        viewBox="0 0 19 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M9.50065 2.57255C5.35851 2.57255 2.00065 5.93041 2.00065 10.0725C2.00065 14.2147 5.35851 17.5725 9.50065 17.5725C13.6428 17.5725 17.0006 14.2147 17.0006 10.0725C17.0006 5.93041 13.6428 2.57255 9.50065 2.57255ZM0.333984 10.0725C0.333984 5.00994 4.43804 0.905884 9.50065 0.905884C14.5633 0.905884 18.6673 5.00994 18.6673 10.0725C18.6673 15.1352 14.5633 19.2392 9.50065 19.2392C4.43804 19.2392 0.333984 15.1352 0.333984 10.0725Z"
                          fill="#002A85"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M9.50065 9.23922C9.96089 9.23922 10.334 9.61231 10.334 10.0725V13.4059C10.334 13.8661 9.96089 14.2392 9.50065 14.2392C9.04041 14.2392 8.66732 13.8661 8.66732 13.4059V10.0725C8.66732 9.61231 9.04041 9.23922 9.50065 9.23922Z"
                          fill="#002A85"
                        />
                        <path
                          d="M10.334 6.73922C10.334 7.19945 9.96089 7.57255 9.50065 7.57255C9.04041 7.57255 8.66732 7.19945 8.66732 6.73922C8.66732 6.27898 9.04041 5.90588 9.50065 5.90588C9.96089 5.90588 10.334 6.27898 10.334 6.73922Z"
                          fill="#002A85"
                        />
                      </svg>
                      <span class="section__neg-text"
                        >Demander une négociation</span
                      >
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <div class="button__footer">
                    <button
                      @click="prevStep()"
                      :disabled="step === 1"
                      class="btn btn-default__cancel mr-2"
                    >
                      Retour
                    </button>
                    <button
                      class="btn btn-primary__save"
                      :class="loading ? 'disabled' : ''"
                      @click="saveAssurance()"
                    >
                      {{ getText() }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="payment__info">
      <div class="payment__info--text">Moyens de paiement acceptés</div>
      <div class="payment__widget">
        <img :src="$assets('images/payment.png')" width="140" alt="payment" />
      </div>
    </div>
    <div class="voyage__info">
      <div
        class="happy__young"
        :style="`background: url(${$assets(
          'images/young.png'
        )}) no-repeat center;background-size: cover;`"
      ></div>
      <div class="hire__me">
        <div class="background__info">
          <div class="svg__hire">
            <svg
              width="188"
              height="188"
              viewBox="0 0 188 188"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M187.6 63.3316C187.6 78.2084 182.026 91.8455 172.801 102.59C174.531 107.549 177.606 113.128 183.372 117.053C184.717 118.087 184.333 120.359 182.603 120.566C176.645 121.393 166.65 121.599 157.233 115.607C152.428 118.5 147.239 120.773 141.665 122.632C140.127 83.374 106.493 51.7607 65.5547 51.7607C62.2874 51.7607 59.02 51.9674 55.9449 52.3806C61.5186 23.0402 88.6184 0.724976 121.292 0.724976C157.809 0.724976 187.6 28.8256 187.6 63.3316ZM12.7005 162.097C4.82044 151.559 0.399902 138.955 0.399902 125.938C0.399902 91.6389 29.6139 63.9515 65.3625 63.9515C101.303 63.9515 130.325 91.8455 130.325 125.938C130.325 160.238 101.111 187.925 65.3625 187.925C54.0229 187.925 42.8755 185.032 33.0734 179.66C27.8841 182.346 22.1182 183.586 15.9679 183.586C13.8537 183.586 11.7395 183.379 9.62537 183.173C6.55021 182.759 4.24385 180.28 3.47506 177.181C2.89847 173.875 4.05165 170.775 6.55021 168.916C9.24097 167.263 11.1629 164.99 12.7005 162.097ZM23.4636 156.932L25.7699 159.618L24.6167 163.13C23.6558 166.023 22.3104 168.916 20.5806 171.189C24.2323 170.569 27.4997 169.329 30.3827 167.469L33.2656 165.61L36.1486 167.263C44.9896 172.635 55.1761 175.528 65.5547 175.528C95.1531 175.528 119.37 153.212 119.37 125.525C119.37 97.8375 95.1531 75.5223 65.5547 75.5223C35.9564 75.5223 11.7395 97.8375 11.7395 125.525C11.7395 137.302 15.7757 148.047 23.4636 156.932ZM67.2845 112.094C71.1284 112.094 74.3958 108.582 74.3958 104.243C74.3958 99.9038 71.3206 96.3912 67.2845 96.3912C63.2484 96.3912 59.981 99.9038 59.981 104.036C59.981 108.582 63.2484 112.094 67.2845 112.094ZM54.5995 119.326C55.3683 119.533 56.1371 119.74 56.9059 119.74C58.8278 119.946 59.4044 120.773 59.4044 122.839C59.4044 123.045 59.4044 123.459 59.4044 123.665C58.6356 128.418 57.8668 133.377 57.0981 138.129C56.7137 140.815 56.3293 143.708 55.9449 146.6C55.3683 150.733 59.02 154.452 61.903 155.072C63.6328 155.279 65.3625 155.485 67.0923 155.279C70.9362 155.279 74.0114 153.419 76.7022 150.733C77.0866 150.32 77.471 149.493 77.6632 148.873C77.8553 147.634 77.0866 147.014 75.9334 147.427C75.1646 147.634 74.588 148.253 73.8192 148.46C72.8582 148.873 72.0894 149.08 71.1284 149.287C69.9753 149.493 69.2065 148.873 69.0143 147.634C68.8221 146.807 68.6299 145.774 68.8221 144.947C69.0143 143.088 69.3987 141.228 69.5909 139.369C70.5519 133.79 71.5128 128.211 72.4738 122.839C72.666 121.393 73.0504 119.74 72.8582 118.293C72.8582 116.434 71.8972 115.607 70.1675 115.607C67.8611 115.607 65.5547 115.607 63.0562 115.607C60.942 115.607 58.6356 115.607 56.5215 115.607C55.9449 115.607 55.3683 115.607 54.7917 115.814C53.8307 116.02 53.2541 116.64 53.2541 117.467C53.2541 118.087 53.6385 118.913 54.5995 119.326Z"
                fill="#E8EFFF"
              />
            </svg>
          </div>
          <div class="hire__me--text">Contactez-nous</div>
          <div class="hire__me--description">
            Si vous avez des questions ou rencontrez une difficulté,
            contactez-nous au {{ settings.support_phone }} ou envoyez-nous un e-mail à {{ settings.support_email }}
          </div>
          <div class="hire__me--button">
            <button class="btn btn-secondary">Parler à un expert</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import { api } from "../../../../helpers/shared";
import FileUpload from "../../../../components/upload/FileUpload.vue";

export default {
  components: { FileUpload },
  name: "voyage",
  props: ["subscription"],
  watch: {
    step: function (val) {
      this.form.step = val;
    },
  },
  data: () => ({
    errors: [],
    ages_section: [
      { id: 2, name: "Moins de 18 ans", min_age: 1, max_age: 17, slug: "1-17" },
      {
        id: 1,
        name: "De 18 à 80 ans",
        min_age: 18,
        max_age: 80,
        slug: "18-80",
      },
    ],
    files: [],
    zone_section: [],
    durations: [],
    step: 1,
    element: 0,
    loading: false,
    summary: {},
    form: {
      step: 1,
      amount: 0,
      product_id: 3,
      data: {
        number_of_people_to_be_insured: "",
        first_name: "",
        last_name: "",
        name: "",
        email: "",
        address: "",
        phone: "",
        other_people: [],
        birthday: "",
        passport_number: "",
        destination_area: "",
        travel_time: "",
      },
    },
  }),
  mounted() {
    this.initializeForm(this.subscription);
    this.getZone();
    this.getDurations();
  },
  methods: {
    initializeForm(element) {
      let { amount, data, product_id, step } = element;
      this.form.step = step;
      this.form.amount = amount;
      this.form.product_id = product_id;
      this.form.data = data;
    },
    saveForLate() {
      if (
        Object.keys(this.summary).length === 0 &&
        this.summary.constructor === Object
      ) {
        this.$toasted.global.error({
          message: "Vous devez completer la première étape",
        });
      } else {
        this.form.amount = this.summary.total;
        axios
          .post(api("subscription/save-for-late"), this.form)
          .then((response) => {
            if (response.data.status) {
              this.$toasted.global.all({
                message: "La souscription a été enrégistrée",
              });
              setTimeout(() => {
                window.location.reload();
              }, 400);
            } else this.$toasted.global.error();
          })
          .catch((error) => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
            } else
              this.$toasted.global.error({
                message:
                  "Vous devez vous connecter pour procéder à cette opération",
              });
          });
      }
    },
    saveNegotiated() {
      this.form.amount = this.summary.total;
      axios
        .post(
          api("subscription/negotiated/" + this.subscription.uuid),
          this.form
        )
        .then((response) => {
          if (response.data.status) {
            this.$toasted.global.all({
              message: "La demande de négociation a été enregistrée",
            });
            setTimeout(() => {
              this.$router("/administration/subscriptions");
            }, 400);
          } else this.$toasted.global.error();
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
          } else
            this.$toasted.global.error({
              message:
                "Vous devez vous connecter pour procéder à cette opération",
            });
        });
    },
    checkAmount() {
      axios
        .post(api("bills"), { bill: "voyage", data: this.form.data })
        .then((response) => {
          this.loading = false;
          console.log(response);
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
          }
          this.loading = false;
        });
    },
    saveAssurance() {
      if (this.step === 3) {
        this.form.amount = this.summary.total;
        this.addBasket();
      } else {
        if (this.step == 1) {
          const loader = this.$loading.show({
            container: null,
            canCancel: false,
            color: "#4B4B4B",
            backgroundColor: "#4B4B4B",
            height: 35,
            width: 35,
            loader: "bars",
            opacity: 0.3,
          });
          this.loading = true;
          axios
            .post(api("assurances/voyage/save"), this.form)
            .then((response) => {
              this.loading = false;
              loader.hide();
              if (response.data.status) {
                this.summary = response.data.content;
                this.errors = [];
                this.nextStep();
              } else this.$toasted.global.error();
            })
            .catch((error) => {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
              }
              this.loading = false;
              loader.hide();
            });
        } else {
          this.nextStep();
        }
      }
    },
    getZone() {
      if (this.form.data.birthday !== "") {
        this.loading = true;
        this.zone_section = [];
        axios
          .get(api("zone?id=" + this.form.data.birthday))
          .then((response) => {
            this.loading = false;
            this.zone_section = response.data;
          })
          .catch((error) => {
            console.log(error);
            this.loading = false;
          });
      }
    },
    getZoneChild(item) {
      if (item.birthday !== "") {
        item.zone_section = [];
        item.durations = [];
        item.travel_time = "";
        item.destination_area = "";
        axios
          .get(api("zone?id=" + item.birthday))
          .then((response) => {
            item.zone_section = response.data;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getDurationsChild(item) {
      if (item.destination_area !== "") {
        axios
          .get(api("durations?id=" + item.destination_area))
          .then((response) => {
            item.durations = response.data.durations;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getDurations() {
      if (this.form.data.destination_area !== "") {
        this.loading = true;
        axios
          .get(api("durations?id=" + this.form.data.destination_area))
          .then((response) => {
            this.loading = false;
            this.durations = response.data.durations;
          })
          .catch((error) => {
            console.log(error);
            this.loading = false;
          });
      }
    },
    single() {
      this.element = 0;
      this.zone_section = [];
      this.durations = [];
      this.destination_area = "";
      this.birthday = "";
      this.form.data.other_people = [];
    },
    group() {
      this.element = 1;
      this.zone_section = [];
      this.durations = [];
      this.destination_area = "";
      this.birthday = "";

      this.form.data.other_people.push({
        name: "",
        last_name: "",
        first_name: "",
        birthday: "",
        passport_number: "",
        destination_area: "",
        travel_time: "",
        zone_section: [],
        durations: [],
      });
    },
    addUser() {
      this.form.data.other_people.push({
        name: "",
        last_name: "",
        first_name: "",
        birthday: "",
        passport_number: "",
        destination_area: "",
        travel_time: "",
        zone_section: [],
        durations: [],
      });
    },
    removeUser(element) {
      if (this.form.data.other_people.length !== 1) {
        let index = this.form.data.other_people.indexOf(element);
        this.form.data.other_people.splice(index, 1);
      } else {
        this.$toasted.global.error({
          message:
            "En selectionnant l'option groupe, vous devez ajouter au moins un utilisateur",
        });
      }
    },
    nextStep() {
      if (this.step < 3) this.step++;
      if (this.step === 2) {
        this.$refs.upload.reloadView();
      }
    },
    prevStep() {
      if (this.step !== 1) this.step--;
      if (this.step === 2) {
        this.$refs.upload.reloadView();
      }
    },
    titleStep() {
      switch (this.step) {
        case 1:
          return "Informations";
          break;
        case 2:
          return "Fichiers joints";
          break;
        case 3:
          return "Résultat";
          break;
      }
    },
    getText() {
      switch (this.step) {
        case 1:
          return "Suivant";
          break;
        case 2:
          return "Suivant";
          break;
        case 3:
          return "Ajouter au panier";
          break;
      }
    },
    addBasket() {
      if (this.$store.state.upload.files.length > 0) {
        const loader = this.$loading.show({
          container: null,
          canCancel: false,
          color: "#4B4B4B",
          backgroundColor: "#4B4B4B",
          height: 35,
          width: 35,
          loader: "bars",
          opacity: 0.3,
        });
        let form = new FormData();
        this.$store.state.upload.files.map((file, key) => {
          form.append("files[" + key + "]", file);
        });
        axios
          .post(api("administration/file/upload"), form, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            loader.hide();
            if (response.data.status) {
              this.files = response.data.files;
              let carts = this.$storage.getItem("carts");
              if (carts) {
                let data = JSON.parse(this.$storage.decryptString(carts));
                data.push({
                  product: this.form,
                  detail: this.summary,
                  check: true,
                  files: this.files,
                  uuids: this.$uuid(),
                  uuid: this.subscription.uuid,
                });
                //localStorage.setItem('carts', JSON.stringify(data));
                this.$storage.setItem(
                  "carts",
                  this.$storage.encryptString(JSON.stringify(data))
                );
                this.$toasted.global.all({
                  message: "Le produit est ajouté au panier",
                });
                setTimeout(() => {
                  window.location.href = "/pannier";
                }, 500);
              } else {
                const products = JSON.stringify([
                  {
                    product: this.form,
                    detail: this.summary,
                    check: true,
                    files: this.files,
                    uuids: this.$uuid(),
                    uuid: this.subscription.uuid,
                  },
                ]);
                this.$storage.setItem(
                  "carts",
                  this.$storage.encryptString(products)
                );
                this.$toasted.global.all({
                  message: "Le produit est ajouté au panier",
                });
                setTimeout(() => {
                  window.location.href = "/pannier";
                }, 500);
              }
            } else this.$toasted.global.error();
          })
          .catch(() => {
            loader.hide();
            this.$toasted.global.error({
              message: "Impossible d'ajouter le produit au panier",
            });
          });
      } else {
        let carts = this.$storage.getItem("carts");
        if (carts) {
          let data = JSON.parse(this.$storage.decryptString(carts));
          data.push({
            product: this.form,
            detail: this.summary,
            check: true,
            uuids: this.$uuid(),
            uuid: this.subscription.uuid,
          });
          //localStorage.setItem('carts', JSON.stringify(data));
          this.$storage.setItem(
            "carts",
            this.$storage.encryptString(JSON.stringify(data))
          );
          this.$toasted.global.all({
            message: "Le produit est ajouté au panier",
          });
          setTimeout(() => {
            window.location.href = "/pannier";
          }, 500);
        } else {
          const products = JSON.stringify([
            {
              product: this.form,
              detail: this.summary,
              check: true,
              uuids: this.$uuid(),
              uuid: this.subscription.uuid,
            },
          ]);
          this.$storage.setItem("carts", this.$storage.encryptString(products));
          this.$toasted.global.all({
            message: "Le produit est ajouté au panier",
          });
          setTimeout(() => {
            window.location.href = "/pannier";
          }, 500);
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.breadcrumb {
  margin-left: -16px;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  background-color: #e8f1ff;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  font-size: 14px;
}
.page__header--info {
  display: grid;
  height: 60px;
  margin-bottom: 10px;
  grid-template-columns: 3fr 1fr;
  .page__header--info__text {
    color: #001e5f;
    font-size: 16px;
    line-height: 25px;
    letter-spacing: -0.3px;
    font-weight: bold;
    align-self: center;
  }
  .page__header--info__icon {
    place-self: center;
    cursor: pointer;
  }
}
.custom__badge_default {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  border: 3px solid #d6d6dc;
  color: #d6d6dc;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
}
.step__voyage--item {
  display: grid;
  grid-template-columns: 1fr 240px;
  justify-content: center;
  align-items: center;
}
.custom__badge--active {
  background-color: #d39e0a;
  color: #ffffff;
  border: 3px solid #d39e0a !important;
}
.step__voyage {
  display: grid;
  grid-auto-flow: row;
  hr {
    border: 1px solid #d6d6dc;
    color: #d6d6dc;
    width: 310px;
  }
}
.form__label {
  color: #6e6b7b;
}
.badge__text {
  font-size: 19px;
  color: #6e6b7b;
}
.badge__text--active {
  color: #d39e0a;
}
.btn-default:focus,
.btn-default.focus {
  color: #fff;
  background-color: #b9b9c3;
  border-color: #b9b9c3;
}

.btn-default__cancel {
  color: #fff;
  background-color: #b9b9c3;
  border-color: #b9b9c3;
}

.btn-primary__save {
  color: #fff !important;
  background-color: #001e5f !important;
  border-color: #001e5f !important;
}
.delete__user {
  color: #e73d3e;
  cursor: pointer;
}
.user__add {
  color: #001e5f;
  cursor: pointer;
}
.section__information {
  display: grid;
  grid-template-columns: 110px 2fr 110px;
  align-items: baseline;
  .section__information-dote {
    border-bottom: 1px dotted #000000;
  }
  .section__information-price {
    justify-self: end;
    color: #000000;
    font-weight: bold;
  }
  .section__information-text {
    color: #6e6b7b;
  }
}
.section__amount {
  display: grid;
  grid-template-columns: 5fr 1fr;
  .section__amount-text {
    justify-self: end;
    color: #6e6b7b;
  }
  .section__amount-price {
    justify-self: end;
    color: #ea5455;
  }
}
.show__btn {
  display: none;
}

.section__neg {
  cursor: pointer;
}
.section__neg-text {
  color: #002a85;
}

.custom__badge-section {
  display: grid;
  grid-template-columns: 50px 50px 50px;
  justify-content: start;
  align-items: center;
  height: 100px;
  grid-gap: 10px;
}

.subscription__section {
  display: grid;
  grid-template-columns: 1fr 3fr;
  grid-gap: 30px;
}

.button__footer {
  display: grid;
  grid-template-columns: 200px 200px;
  justify-content: end;
}

@media only screen and (max-width: 500px) {
  .button__footer {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}

@media only screen and (max-width: 870px) {
  .hide__subscription-section {
    display: none !important;
  }
  .subscription__section {
    display: grid;
    grid-template-columns: 1fr;
  }
}
@media only screen and (max-width: 992px) {
  .section__amount {
    grid-template-columns: 4fr 2fr;
  }
}
@media only screen and (max-width: 540px) {
  .show__btn {
    display: block;
  }
  .hide__on_mobile {
    display: none !important;
  }
  .hide__btn--large {
    display: none !important;
  }
  .page__header--info .page__header--info__icon {
    place-self: end;
    align-self: center;
  }
}
/*
    .total__info {
        display: grid;
        grid-template-columns: 130px 1fr;
        justify-content: center;
        align-items: center;
        .total__info--price{
            color: #000000;
            font-weight: bold;
        }
    }

     */
</style>

